<template>
  <div class="loading-mask">
    <div>
      {{ $t('portal_components.loading.loading') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading-mask',
};
</script>
